import {API_BASE_URL, PATH_ACTIONS, PATH_TRIGGER} from '../constants/constants';
import {getFingerPrint, request, run} from "./APIService";

export function triggerAction(clientId, actionId, coords) {
    return getFingerPrint().then(response => {
        const fingerPrint = response;
        if (coords) {
            fingerPrint['latitude'] = coords.latitude;
            fingerPrint['longitude'] = coords.longitude;
        }
        return request({
            url: API_BASE_URL + PATH_ACTIONS.replace('{clientId}', clientId) + '/' + actionId + PATH_TRIGGER,
            method: 'POST',
            body: JSON.stringify(fingerPrint)
        }, [])
    });
}

export function getActions(clientId, page, size) {
    return request({
        url: API_BASE_URL + PATH_ACTIONS.replace('{clientId}', clientId) + '?page=' + (page ? page : -1) + '&size=' + (size ? size : -1) + '&order=order:ASC',
        method: 'GET'
    }, []);
}

export function getAllActions(clientId, filters) {
    return getActions(clientId, 0, 100, filters)
}

export function createAction(action) {
    return request({
        url: API_BASE_URL + PATH_ACTIONS.replace('{clientId}', action.clientId),
        method: 'POST',
        body: JSON.stringify(action)
    }, []);
}

export function updateAction(action) {
    return request({
        url: API_BASE_URL + PATH_ACTIONS.replace('{clientId}', action.clientId) + "/" + action.id,
        method: 'PUT',
        body: JSON.stringify(action)
    }, []);
}

export function deleteAction(action) {
    return run({
        url: API_BASE_URL + PATH_ACTIONS.replace('{clientId}', action.clientId) + "/" + action.id,
        method: 'DELETE'
    }, []);
}


// WEBPACK FOOTER //
// ./src/app/services/ActionsService.js